type GameConceptReviewBannerState = Readonly<{
  isNdaSigned: boolean;
  isEnrollmentFinished: boolean;
  isIdXboxApproved: boolean;
  isFastTrackAccount: boolean;
  hasGameConceptUnderReview: boolean;
  hasApprovedGameConcept: boolean;
  hasGameConceptWithTlaReceived: boolean;
}>;

type AdditionalContractsState = Readonly<{
  isFastTrackAccount: boolean;
  hasApprovedGameConcept: boolean;
  hasGameConceptWithTlaReceived: boolean;
  isGdkSigned: boolean;
}>;

type BannerVisibilityState = Readonly<{
  isNdaSigned: boolean;
  isEnrollmentFinished: boolean;
  isIdXboxApproved: boolean;
  isFastTrackAccount: boolean;
}>;

type AdditionalContractsBannerVisibilityState = BannerVisibilityState &
  Readonly<{
    hasApprovedGameConcept: boolean;
    needsTlaSignature: boolean;
    needsGdkSignature: boolean;
  }>;

type GameConceptRequiredBannerState = BannerVisibilityState &
  Readonly<{
    hasGameConceptWithTlaReceived: boolean;
    hasSubmittedGameConcept: boolean;
  }>;

export { isPartnerCenterEnrollmentFinished } from "../../helpers/partnerEnrollmentHelpers";

export const getAdditionalContractsBannerState = ({
  isFastTrackAccount,
  hasApprovedGameConcept,
  hasGameConceptWithTlaReceived,
  isGdkSigned,
}: AdditionalContractsState) => {
  const needsTlaSignature =
    !isFastTrackAccount && hasApprovedGameConcept && !hasGameConceptWithTlaReceived;
  const needsGdkSignature = !isGdkSigned;
  const messageKey = isFastTrackAccount
    ? "partnerHomeFastTrackGdkContractPending"
    : needsTlaSignature && needsGdkSignature
    ? "partnerHomeTlaAndGdkContractsPending"
    : needsTlaSignature
    ? "partnerHomeTlaContractPending"
    : "partnerHomeGdkContractPending";

  return {
    needsTlaSignature,
    needsGdkSignature,
    messageKey,
  };
};

export const shouldShowAdditionalContractsBanner = ({
  isNdaSigned,
  isEnrollmentFinished,
  isIdXboxApproved,
  isFastTrackAccount,
  hasApprovedGameConcept,
  needsTlaSignature,
  needsGdkSignature,
}: AdditionalContractsBannerVisibilityState): boolean =>
  isNdaSigned &&
  isEnrollmentFinished &&
  isIdXboxApproved &&
  (isFastTrackAccount
    ? needsGdkSignature
    : hasApprovedGameConcept && (needsTlaSignature || needsGdkSignature));

export const shouldShowGameConceptRequiredBanner = ({
  isNdaSigned,
  isEnrollmentFinished,
  isIdXboxApproved,
  isFastTrackAccount,
  hasGameConceptWithTlaReceived,
  hasSubmittedGameConcept,
}: GameConceptRequiredBannerState): boolean =>
  isNdaSigned &&
  isEnrollmentFinished &&
  isIdXboxApproved &&
  !isFastTrackAccount &&
  !hasGameConceptWithTlaReceived &&
  !hasSubmittedGameConcept;

export const shouldShowGameConceptReviewBanner = ({
  isNdaSigned,
  isEnrollmentFinished,
  isIdXboxApproved,
  isFastTrackAccount,
  hasGameConceptUnderReview,
  hasApprovedGameConcept,
  hasGameConceptWithTlaReceived,
}: GameConceptReviewBannerState): boolean =>
  isNdaSigned &&
  isEnrollmentFinished &&
  isIdXboxApproved &&
  !isFastTrackAccount &&
  hasGameConceptUnderReview &&
  !hasApprovedGameConcept &&
  !hasGameConceptWithTlaReceived;
